// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hTte","colBig":"styles_colBig__2zwto","colSmall":"styles_colSmall__1WrjK"};